var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title_left"},[_c('img',{attrs:{"src":_vm.iconImg,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.name))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/images/overview/title.png"),"alt":""}})])
}]

export { render, staticRenderFns }